export const sortJsonArrayHelper = {

	data() {
		return {

		}
	},
	methods: {
		sortJsonArray(arr, prop, order) {

			if (arr == null) {
				return [];
			}

			if (!Array.isArray(arr)) {
				throw new TypeError('sort-json-array expects an array.');
			}

			if (arguments.length === 1) {
				return arr.sort();
			}

			if (order == null || order == "asc") {
				return arr.sort(this.compare(prop, 1));
			} else if (order == "des") {
				return arr.sort(this.compare(prop, 0));
			} else {
				throw new TypeError('Wrong argument.');
			}

		},
		compare(attr, value) {
			if (value) {
				return function (a, b) {
					var x = (a[attr] === null) ? "" : "" + a[attr],
						y = (b[attr] === null) ? "" : "" + b[attr];
					if (isNaN(x) || isNaN(y)) {
						return x < y ? -1 : (x > y ? 1 : 0)
					} else {
						return x - y
					}
				}
			} else {
				return function (a, b) {
					var x = (a[attr] === null) ? "" : "" + a[attr],
						y = (b[attr] === null) ? "" : "" + b[attr];
					if (isNaN(x) || isNaN(y)) {
						return x < y ? 1 : (x > y ? -1 : 0)
					} else {
						return y - x
					}
				}
			}
		}
	}
}
